import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  AIR_FILTER_ACCORDION_TABS_QUESTIONS,
  getAirFilterQuestions,
  getTurbochargerQuestions,
  isSelected,
} from "./air-system-helper";
import { convertToCamelCaseFromUnderScore } from "../../../../../utils";
import SiDatePicker from "../../../../../core/si-datepicker";

const AirSystem = ({ checklistDetails, setChecklistDetails }) => {
  const [details, setDetails] = useState(
    checklistDetails?.checkList?.airSystem || {}
  );
  const [expanded, setExpanded] = useState("");

  const handleAccordionChange = (panel) => {
    setExpanded(expanded === panel ? "" : panel);
  };

  const onChange = (question, option) => {
    const { apiKey } = question;
    const { apiOptionKey } = option;
    const updatedDetails = { ...details };

    if (question.type === "RADIO") {
      updatedDetails[apiKey] = option.label;
    } else {
      updatedDetails[apiOptionKey] = !updatedDetails[apiOptionKey];
    }

    setDetails(updatedDetails);
  };

  const getQuestions = (key) => {
    if (key === "Air Intake & Exhaust System") {
      return getAirFilterQuestions(details);
    } else if (key === "Aspiration") {
      return getTurbochargerQuestions(details);
    }
    return AIR_FILTER_ACCORDION_TABS_QUESTIONS[key] || [];
  };

  useEffect(() => {
    setChecklistDetails((prevVal) => ({
      ...prevVal,
      checkList: {
        ...prevVal.checkList,
        airSystem: details,
      },
    }));
  }, [details]);
  console.log(details);
  return (
    <div style={{ padding: 16 }}>
      <Typography variant="h6" gutterBottom>
        Air System
      </Typography>
      {Object.keys(AIR_FILTER_ACCORDION_TABS_QUESTIONS).map((key) => (
        <Accordion
          key={key}
          expanded={expanded === key}
          onChange={() => handleAccordionChange(key)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{key}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {getQuestions(key).map((question, index) => (
              <div key={question.label} style={{ marginBottom: 24 }}>
                <Typography variant="subtitle1">
                  {index + 1}. {question.label}
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  {question.type === "DATE" && (
                    <Grid item xs={12} sm={6} md={4}>
                      <SiDatePicker
                        placeholder={question.label}
                        value={
                          details[question.apiKey]
                            ? new Date(details[question.apiKey])
                            : null
                        }
                        onChange={(value) =>
                          setDetails({
                            ...details,
                            [question.apiKey]: value.toDate(),
                          })
                        }
                      />
                    </Grid>
                  )}

                  {question.type === "INPUT" && (
                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        fullWidth
                        label={question.label}
                        value={details[question.apiKey] || ""}
                        onChange={(e) =>
                          setDetails({
                            ...details,
                            [question.apiKey]: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  )}

                  {question.type === "RADIO" ? (
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        value={details[question.apiKey] || ""}
                        onChange={(e) =>
                          setDetails({
                            ...details,
                            [question.apiKey]: e.target.value,
                          })
                        }
                      >
                        {question.options.map((option) => (
                          <FormControlLabel
                            key={option.label}
                            value={option.label}
                            control={<Radio />}
                            label={convertToCamelCaseFromUnderScore(
                              option.label
                            )}
                          />
                        ))}
                      </RadioGroup>
                    </Grid>
                  ) : (
                    question.options.map((option) => (
                      <Grid item xs={12} sm={6} md={4} key={option.label}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                isSelected(details, question, option) || false
                              }
                              onChange={() => onChange(question, option)}
                            />
                          }
                          label={convertToCamelCaseFromUnderScore(option.label)}
                        />
                      </Grid>
                    ))
                  )}
                </Grid>
              </div>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default AirSystem;
